'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Serviço indisponível, tente de novo mais tarde.',
    NEED_ACTIVE: 'A conta {{account}} está acessando o site pela primeira vez. {{activeLink}} para completar o processo e começar a explorar ofertas!',
    GOTO_ACTIVE: 'Ativar',
    NOT_ACTIVED: 'Essa conta ainda não foi ativada, {{activeLink}} para completar o processo.',
    COMPLETE_ACTIVE: 'Confirmar Ativação',
    FORBID_ACTIVE: 'Conta indisponível no AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Tente entrar com outra conta',
    ACTIVE_PAGE: 'Faça a ativação da conta'
};